<template>
  <div class="main-container">
    <div class="main-container-title-box">
      <div class="main-container-title-box-text">
        <span class="title-box-text">Истории</span>
      </div>
      <div>
        <v-btn depressed outlined color="var(--app-dark-blue-1)" class="button-accept"
          style="width: 229px !important" @click="goToCreate">
          <span>+ Создать историю</span>
        </v-btn>
      </div>
    </div>
    <div v-if="loading">
      <v-data-table
        :headers="tableHeaders"
        item-key="id"
        :items="storiesList"
        :show-select="false"
        :disable-pagination="true"
        :hide-default-footer="true"
        hide-default-header
        class="elevation-0"
      >
        <template v-slot:header>
          <thead>
            <tr>
              <th v-for="(s, index) in tableHeaders" :key="index" class="text-left">
                <div style="max-width: 100px !important" v-if="s.text == 'Порядок отображения'">
                  {{ s.text }}
                </div>
                <div v-else>
                  {{ s.text }}
                </div>
              </th>
            </tr>
          </thead>
        </template>
        <template slot="body">
          <draggable :list="storiesList" tag="tbody" @end="endDrag" :move="checkMove"
            :style="moveItems ? 'pointer-events: none;' : ''">
            <tr v-for="(item, index) in storiesList" :key="item.id" @click="goToStory(item)"
              style="height: auto; cursor: pointer">
              <td>
                <v-icon small style="cursor: pointer" :disabled="moveItems ? true : false">
                  mdi-menu
                </v-icon>
              </td>
              <td>
                {{ index + 1 }}
              </td>
              <td>
                {{ item.title }}
              </td>
              <td>
                {{ item.type === 'image' ? 'Карточки' : 'Видео' }}
              </td>
              <td>
                <img v-if="item.previewImageUrl" :src="item.previewImageUrl" class="preview-img" />
                <span v-else>—</span>
              </td>
              <td>
                <v-icon v-if="item.isVisible" color="var(--app-green-1)">mdi-check-circle</v-icon>
                <v-icon v-else color="#929292">mdi-close-circle-outline</v-icon>
              </td>
            </tr>
          </draggable>
        </template>
      </v-data-table>
    </div>
  </div>
</template>

<script>
import draggable from "vuedraggable";
export default {
  components: {
    draggable,
  },
  mounted() {
    this.getStories();
  },
  data: () => ({
    loading: false,
    storiesList: [],
    moveItems: false,
    selectedDrag: "",
    tableHeaders: [
      { text: '', sortable: false },
      { text: 'Порядок отображения', value: '', sortable: false },
      { text: 'Заголовок', sortable: false, value: 'title', width: '45%' },
      { text: 'Тип', sortable: false, value: 'type', width: '15%' },
      { text: 'Превью', sortable: false, value: 'previewImageUrl', width: '15%' },
      { text: 'Видимость', sortable: false, value: 'isVisible', width: '15%' },
    ],
  }),
  methods: {
    goToStory(item) {
      this.$router.push({ name: 'StoryCreate', params: { id: item.id } });
    },
    goToCreate() {
      this.$router.push({ name: 'StoryCreate' });
    },
    getStories() {
      this.$axios
        .get(this.$store.getters.apiAdminPanelV5 + '/stories/list', {
          headers: {
            authorization: this.$store.getters.adminPanelHeaderAuth,
            'secret-key': this.$store.state.secretKeyCookie,
          },
        })
        .then((res) => {
          this.storiesList = [...res.data].sort((a, b) => a.index - b.index);
          this.loading = true;
        })
        .catch((err) => {
          this.$store.commit('errorSet', true);
          this.$store.commit('errorTextSet', err);
        });
    },
    endDrag(evt) {
      this.moveItems = true;
      this.$axios
        .patch(
          this.$store.getters.apiAdminPanelV5 + '/stories/sort',
          {
            id: this.selectedDrag,
            index: evt.newIndex + 1,
          },
          {
            headers: {
              authorization: this.$store.getters.adminPanelHeaderAuth,
              'secret-key': this.$store.state.secretKeyCookie,
            },
          }
        )
        .then(() => {
          this.getStories();
          this.moveItems = false;
        })
        .catch((err) => {
          this.$store.commit('errorSet', true);
          this.$store.commit('errorTextSet', err);
          this.moveItems = false;
        });
    },
    checkMove(evt) {
      this.selectedDrag = evt.draggedContext.element.id;
    },
  },
};
</script>

<style lang="scss" scoped>
.preview-img {
  width: 60px;
  height: 40px;
  object-fit: cover;
  border-radius: 4px;
  margin: 6px 0;
}
</style>
